"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVALID_MODULE = exports.SelectModule = exports.InputModule = exports.LabeledModule = exports.SurveyModule = void 0;
const util_1 = require("./util");
class SurveyModule {
    constructor({ actionRequired = false, id, languageCode = "en", noBorder = false, style = {}, tag, data, }) {
        this.actionRequired = actionRequired;
        this._id = id || (0, util_1.generateUUID)();
        this.noBorder = noBorder;
        this.style = style;
        this._languageCode = languageCode;
        this.data = data;
        if (tag) {
            this.tag = tag;
        }
    }
    get id() {
        return this._id;
    }
    get type() {
        return this._type;
    }
    get languageCode() {
        return this._languageCode;
    }
    set languageCode(langCode) {
        this._languageCode = langCode;
    }
}
exports.SurveyModule = SurveyModule;
class LabeledModule extends SurveyModule {
    constructor({ label = { en: "" }, ...rest }) {
        super(rest);
        this.label = label;
    }
}
exports.LabeledModule = LabeledModule;
class InputModule extends LabeledModule {
    constructor({ required = true, ...rest }) {
        super(rest);
        this.required = required;
    }
}
exports.InputModule = InputModule;
class SelectModule extends InputModule {
    constructor({ options = [], randomizeOptions = false, ...rest }) {
        super(rest);
        this.options = options;
        this.randomizeOptions = randomizeOptions;
    }
}
exports.SelectModule = SelectModule;
const INVALID_MODULE = (mod) => `unable to validate ${mod.type} module`;
exports.INVALID_MODULE = INVALID_MODULE;
//# sourceMappingURL=base.js.map